import { LoadingSpinner } from '@components/common';
import './PageLoader.css';

const PageLoader = () => {
  return (
    <div className="page-loader">
      <LoadingSpinner size="lg" />
    </div>
  );
};

export default PageLoader;
